import { Button } from "common/components/ui/Button";
import {
  DialogClose,
  DialogFooter,
  DialogHeader,
} from "common/components/ui/Dialog";
import {
  DrawerClose,
  DrawerFooter,
  DrawerHeader,
} from "common/components/ui/Drawer";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

import useAudienceMutations from "../../../datahooks/useAudienceMutations";

import type { AudienceFilters, AudienceProfile } from "../../../types";

interface RemoveTargetsProps {
  selectedTargets: AudienceProfile[];
  onSuccess: () => void;
  onBack?: () => void;
  filters?: AudienceFilters;
}

export default function RemoveTargets({
  selectedTargets,
  onSuccess,
  onBack,
  filters,
}: RemoveTargetsProps) {
  const isDesktop = useTwBreakpoint("lg");

  const Footer = isDesktop ? DialogFooter : DrawerFooter;
  const Header = isDesktop ? DialogHeader : DrawerHeader;
  const Close = isDesktop ? DialogClose : DrawerClose;

  const { removeProfiles, isRemovingProfiles } = useAudienceMutations(filters);

  const eligibleProfiles = selectedTargets.filter(
    ({ state }) => state !== "done" && state !== "cancelled",
  );
  const suffix = eligibleProfiles.length > 1 ? "s" : "";
  const title = "Remove targets?";
  const description = `Are you sure you want to remove ${eligibleProfiles.length} target${suffix} from this campaign?`;

  function onRemove() {
    removeProfiles({
      targetUrns: eligibleProfiles.map(({ urn }) => urn),
    }).then(onSuccess);
  }

  return (
    <>
      <Header title={title} subtitle={description} onBack={onBack} />

      <Footer className="justify-end">
        <Close asChild>
          <Button variant="secondary-black" disabled={isRemovingProfiles}>
            Cancel
          </Button>
        </Close>

        <Button
          variant="outline-danger"
          onClick={onRemove}
          isLoading={isRemovingProfiles}
        >
          Remove
        </Button>
      </Footer>
    </>
  );
}
